const quickLinks = {
    ClubPage: [
        'About this club',
        'Teams at this club',
        'Contact details',
    ],
    HomePage: [
        'Ways to play',
        'Team vs sessional football',
        'England Football programmes',
        'Disability football',
    ],
    TeamPage: [
        'About this team',
        'Fixtures, results and standings',
        'Contact details',
    ],
  };
  export default quickLinks;